export class CommonConstants {
  public static readonly SESSION_USERNAME = 'displayName';
  public static readonly SESSION_GIVENNAME = 'givenName';
  public static readonly SESSION_PERMISSIONS = 'permissions';
  public static readonly SESSION_CUSTOMERTYPE = 'customerType';
  public static readonly SESSION_USERINFO = 'userinfo';
  public static readonly SESSION_USERDETAILS = 'userinfo-additionalInfo';
  public static readonly SESSION_LANGUAGE_CODE = 'languageCode';
  public static readonly SESSION_USERID = 'userId';
  public static readonly SEARCHTEXT_REGEX = /^[A-Za-z0-9\s.,;?!@#$%^&*()_+\-=|{}\\:"'<>/[\]]*$/;
  public static readonly TOASTER_DURATION = 1000;
  public static readonly SESSION_USERTYPE = 'userType';
  public static readonly ASSIGNED_TO_ALLUSERS = 'All Users';
  public static readonly DEFAULT_TEMPLATE = 'Default Template';
  public static readonly TESTPARAMETERSPECIALCHAR = 'Test - Parameter';
  public static readonly LIMITSETTEMPLATE = 'LimitSetTemplate';
  public static readonly EXPORTLIMITSET = 'ExportLimitSet';
  public static readonly EXPORTGROUPS = 'ExportGroups';
  public static readonly DefaultLanguageCode = 'en';
  public static readonly IsInternalUser = 'IsInternalUser';
  public static readonly IsCustomerUser = 'IsCustomerUser';
  public static readonly IsForeignUser = 'IsForeignUser';
}
